import { Navigate, useRoutes } from "react-router-dom";
import _404 from "pages/NotFound404";

import MainLayout from "../layouts/MainLayout";
import DashboardPage from "pages/dashboard";
import DonationsPage from "pages/donations";
import DonationConditionsPage from "pages/donations/conditions";
import CustomizeDonationPage from "pages/donations/CustomizeDonationPage";
import DonationWidgetPublicPage from "pages/donations/DonationWidgetPublicPage";
import DonationWidgetConfig from "components/DonationWidgetConfig";
import LogPage from "pages/log";
import UserPage from "pages/user";
import GamePage from "pages/game";
import GameConditionsPage from "pages/game/conditions";
import LoginPage from "pages/LoginPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import PolicyPage from "pages/PolicyPage";
import VerifyPage from "pages/VerifyPage";
// import TopupPage from "pages/topup";
import PaymentPage from "pages/payment";
import WithdrawPage from "pages/withdraw";
import WithdrawHistoryPage from "pages/withdraw-history";
import MerchantPage from "pages/merchant";
import WalletPage from "pages/wallet";
import ReferralsPage from "pages/referrals/index";
import ReferralDetailPage from "pages/referrals/detail/index";

function Router() {
  return useRoutes([
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/dashboard" replace />,
        },
        {
          path: "dashboard",
          element: <DashboardPage />,
        },
        {
          path: "donations",
          element: <DonationsPage />,
        },
        {
          path: "donations/conditions",
          element: <DonationConditionsPage />,
        },
        {
          path: "donations/widgets",
          element: <DonationWidgetConfig />,
        },
        {
          path: "donations/customize",
          element: <CustomizeDonationPage />,
        },
        {
          path: "user",
          element: <UserPage />,
        },
        {
          path: "game",
          element: <GamePage />,
        },
        {
          path: "game/conditions",
          element: <GameConditionsPage />,
        },
        // {
        //   path: "/topup",
        //   element: <TopupPage />,
        // },
        {
          path: "transaction",
          element: <WalletPage />,
        },
        {
          path: "game-history",
          element: <Navigate to="/transaction" replace />,
        },
        {
          path: "wallet",
          element: <Navigate to="/transaction" replace />,
        },
        {
          path: "payment",
          element: <PaymentPage />,
        },
        {
          path: "withdraw",
          element: <WithdrawPage />,
        },
        {
          path: "withdraw-history",
          element: <WithdrawHistoryPage />,
        },
        {
          path: "merchant",
          element: <MerchantPage />,
        },
        {
          path: "referrals",
          element: <ReferralsPage />,
        },
        {
          path: "referrals/detail",
          element: <ReferralDetailPage />,
        },
        {
          path: "logs",
          element: <LogPage />,
        },
      ],
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/register",
      element: <LoginPage />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPasswordPage />,
    },
    {
      path: "/reset-password",
      element: <ResetPasswordPage />,
    },
    {
      path: "/policy",
      element: <PolicyPage />,
    },
    {
      path: "/verify",
      element: <VerifyPage />,
    },
    {
      path: "/widgets/:publicKey",
      element: <DonationWidgetPublicPage />,
    },
    {
      path: "/widgets/:widgetType/:publicKey",
      element: <DonationWidgetPublicPage />,
    },
    {
      path: "/donate/obs/widget",
      element: <DonationWidgetPublicPage />,
    },
    {
      path: "/donate/obs/goal",
      element: <DonationWidgetPublicPage />,
    },
    {
      path: "*",
      element: <_404 />,
    },
  ]);
}

export default Router;
